type Countries = {
  name: string;
  iso: string;
  countryCode: string;
};

type Country = {
  [key: string]: Countries;
};

export const COUNTRY_DEFAULT_VALUES = {
  name: "",
  iso: "",
  countryCode: "",
};

export const COUNTRIES_PER_NAME: Country = {
  Afghanistan: {
    name: "Afghanistan",
    iso: "+93",
    countryCode: "AF",
  },
  "Åland Islands": {
    name: "Åland Islands",
    iso: "+358",
    countryCode: "AX",
  },
  Albania: {
    name: "Albania",
    iso: "+355",
    countryCode: "AL",
  },
  Algeria: {
    name: "Algeria",
    iso: "+213",
    countryCode: "DZ",
  },
  "American Samoa": {
    name: "American Samoa",
    iso: "+1(684)",
    countryCode: "AS",
  },
  Andorra: {
    name: "Andorra",
    iso: "+376",
    countryCode: "AD",
  },
  Angola: {
    name: "Angola",
    iso: "+244",
    countryCode: "AO",
  },
  Anguilla: {
    name: "Anguilla",
    iso: "+1(264)",
    countryCode: "AI",
  },
  Antarctica: {
    name: "Antarctica",
    iso: "+672",
    countryCode: "AQ",
  },
  "Antigua and Barbuda": {
    name: "Antigua and Barbuda",
    iso: "+1(268)",
    countryCode: "AG",
  },
  Argentina: {
    name: "Argentina",
    iso: "+54",
    countryCode: "AR",
  },
  Armenia: {
    name: "Armenia",
    iso: "+374",
    countryCode: "AM",
  },
  Aruba: {
    name: "Aruba",
    iso: "+297",
    countryCode: "AW",
  },
  Australia: {
    name: "Australia",
    iso: "+61",
    countryCode: "AU",
  },
  Austria: {
    name: "Austria",
    iso: "+43",
    countryCode: "AT",
  },
  Azerbaijan: {
    name: "Azerbaijan",
    iso: "+994",
    countryCode: "AZ",
  },
  Bahamas: {
    name: "Bahamas",
    iso: "+1(242)",
    countryCode: "BS",
  },
  Bahrain: {
    name: "Bahrain",
    iso: "+973",
    countryCode: "BH",
  },
  Bangladesh: {
    name: "Bangladesh",
    iso: "+880",
    countryCode: "BD",
  },
  Barbados: {
    name: "Barbados",
    iso: "+1(246)",
    countryCode: "BB",
  },
  Belarus: {
    name: "Belarus",
    iso: "+375",
    countryCode: "BY",
  },
  Belgium: {
    name: "Belgium",
    iso: "+32",
    countryCode: "BE",
  },
  Belize: {
    name: "Belize",
    iso: "+501",
    countryCode: "BZ",
  },
  Benin: {
    name: "Benin",
    iso: "+229",
    countryCode: "BJ",
  },
  Bermuda: {
    name: "Bermuda",
    iso: "+1(441)",
    countryCode: "BM",
  },
  Bhutan: {
    name: "Bhutan",
    iso: "+975",
    countryCode: "BT",
  },
  "Bolivia, Plurinational State of bolivia": {
    name: "Bolivia, Plurinational State of bolivia",
    iso: "+591",
    countryCode: "BO",
  },
  "Bosnia and Herzegovina": {
    name: "Bosnia and Herzegovina",
    iso: "+387",
    countryCode: "BA",
  },
  Botswana: {
    name: "Botswana",
    iso: "+267",
    countryCode: "BW",
  },
  "Bouvet Island": {
    name: "Bouvet Island",
    iso: "+47",
    countryCode: "BV",
  },
  Brazil: {
    name: "Brazil",
    iso: "+55",
    countryCode: "BR",
  },
  "British Indian Ocean Territory": {
    name: "British Indian Ocean Territory",
    iso: "+246",
    countryCode: "IO",
  },
  "Brunei Darussalam": {
    name: "Brunei Darussalam",
    iso: "+673",
    countryCode: "BN",
  },
  Bulgaria: {
    name: "Bulgaria",
    iso: "+359",
    countryCode: "BG",
  },
  "Burkina Faso": {
    name: "Burkina Faso",
    iso: "+226",
    countryCode: "BF",
  },
  Burundi: {
    name: "Burundi",
    iso: "+257",
    countryCode: "BI",
  },
  Cambodia: {
    name: "Cambodia",
    iso: "+855",
    countryCode: "KH",
  },
  Cameroon: {
    name: "Cameroon",
    iso: "+237",
    countryCode: "CM",
  },
  Canada: {
    name: "Canada",
    iso: "+1",
    countryCode: "CA",
  },
  "Cape Verde": {
    name: "Cape Verde",
    iso: "+238",
    countryCode: "CV",
  },
  "Cayman Islands": {
    name: "Cayman Islands",
    iso: "+1(345)",
    countryCode: "KY",
  },
  "Central African Republic": {
    name: "Central African Republic",
    iso: "+236",
    countryCode: "CF",
  },
  Chad: {
    name: "Chad",
    iso: "+235",
    countryCode: "TD",
  },
  Chile: {
    name: "Chile",
    iso: "+56",
    countryCode: "CL",
  },
  China: {
    name: "China",
    iso: "+86",
    countryCode: "CN",
  },
  "Christmas Island": {
    name: "Christmas Island",
    iso: "+61",
    countryCode: "CX",
  },
  "Cocos (Keeling) Islands": {
    name: "Cocos (Keeling) Islands",
    iso: "+61",
    countryCode: "CC",
  },
  Colombia: {
    name: "Colombia",
    iso: "+57",
    countryCode: "CO",
  },
  Comoros: {
    name: "Comoros",
    iso: "+269",
    countryCode: "KM",
  },
  Congo: {
    name: "Congo",
    iso: "+242",
    countryCode: "CG",
  },
  "Congo, The Democratic Republic of the Congo": {
    name: "Congo, The Democratic Republic of the Congo",
    iso: "+243",
    countryCode: "CD",
  },
  "Cook Islands": {
    name: "Cook Islands",
    iso: "+682",
    countryCode: "CK",
  },
  "Costa Rica": {
    name: "Costa Rica",
    iso: "+506",
    countryCode: "CR",
  },
  "Cote d'Ivoire": {
    name: "Cote d'Ivoire",
    iso: "+225",
    countryCode: "CI",
  },
  Croatia: {
    name: "Croatia",
    iso: "+385",
    countryCode: "HR",
  },
  Cuba: {
    name: "Cuba",
    iso: "+53",
    countryCode: "CU",
  },
  Cyprus: {
    name: "Cyprus",
    iso: "+357",
    countryCode: "CY",
  },
  "Czech Republic": {
    name: "Czech Republic",
    iso: "+420",
    countryCode: "CZ",
  },
  Denmark: {
    name: "Denmark",
    iso: "+45",
    countryCode: "DK",
  },
  Djibouti: {
    name: "Djibouti",
    iso: "+253",
    countryCode: "DJ",
  },
  Dominica: {
    name: "Dominica",
    iso: "+1(767)",
    countryCode: "DM",
  },
  "Dominican Republic": {
    name: "Dominican Republic",
    iso: "+1(849)",
    countryCode: "DO",
  },
  Ecuador: {
    name: "Ecuador",
    iso: "+593",
    countryCode: "EC",
  },
  Egypt: {
    name: "Egypt",
    iso: "+20",
    countryCode: "EG",
  },
  "El Salvador": {
    name: "El Salvador",
    iso: "+503",
    countryCode: "SV",
  },
  "Equatorial Guinea": {
    name: "Equatorial Guinea",
    iso: "+240",
    countryCode: "GQ",
  },
  Eritrea: {
    name: "Eritrea",
    iso: "+291",
    countryCode: "ER",
  },
  Estonia: {
    name: "Estonia",
    iso: "+372",
    countryCode: "EE",
  },
  Ethiopia: {
    name: "Ethiopia",
    iso: "+251",
    countryCode: "ET",
  },
  "Falkland Islands (Malvinas)": {
    name: "Falkland Islands (Malvinas)",
    iso: "+500",
    countryCode: "FK",
  },
  "Faroe Islands": {
    name: "Faroe Islands",
    iso: "+298",
    countryCode: "FO",
  },
  Fiji: {
    name: "Fiji",
    iso: "+679",
    countryCode: "FJ",
  },
  Finland: {
    name: "Finland",
    iso: "+358",
    countryCode: "FI",
  },
  France: {
    name: "France",
    iso: "+33",
    countryCode: "FR",
  },
  "French Guiana": {
    name: "French Guiana",
    iso: "+594",
    countryCode: "GF",
  },
  "French Polynesia": {
    name: "French Polynesia",
    iso: "+689",
    countryCode: "PF",
  },
  "French Southern Territories": {
    name: "French Southern Territories",
    iso: "+262",
    countryCode: "TF",
  },
  Gabon: {
    name: "Gabon",
    iso: "+241",
    countryCode: "GA",
  },
  Gambia: {
    name: "Gambia",
    iso: "+220",
    countryCode: "GM",
  },
  Georgia: {
    name: "Georgia",
    iso: "+995",
    countryCode: "GE",
  },
  Germany: {
    name: "Germany",
    iso: "+49",
    countryCode: "DE",
  },
  Ghana: {
    name: "Ghana",
    iso: "+233",
    countryCode: "GH",
  },
  Gibraltar: {
    name: "Gibraltar",
    iso: "+350",
    countryCode: "GI",
  },
  Greece: {
    name: "Greece",
    iso: "+30",
    countryCode: "GR",
  },
  Greenland: {
    name: "Greenland",
    iso: "+299",
    countryCode: "GL",
  },
  Grenada: {
    name: "Grenada",
    iso: "+1(473)",
    countryCode: "GD",
  },
  Guadeloupe: {
    name: "Guadeloupe",
    iso: "+590",
    countryCode: "GP",
  },
  Guam: {
    name: "Guam",
    iso: "+1(671)",
    countryCode: "GU",
  },
  Guatemala: {
    name: "Guatemala",
    iso: "+502",
    countryCode: "GT",
  },
  Guernsey: {
    name: "Guernsey",
    iso: "+44",
    countryCode: "GG",
  },
  Guinea: {
    name: "Guinea",
    iso: "+224",
    countryCode: "GN",
  },
  "Guinea-Bissau": {
    name: "Guinea-Bissau",
    iso: "+245",
    countryCode: "GW",
  },
  Guyana: {
    name: "Guyana",
    iso: "+592",
    countryCode: "GY",
  },
  Haiti: {
    name: "Haiti",
    iso: "+509",
    countryCode: "HT",
  },
  "Heard Island and Mcdonald Islands": {
    name: "Heard Island and Mcdonald Islands",
    iso: "+0",
    countryCode: "HM",
  },
  "Holy See (Vatican City State)": {
    name: "Holy See (Vatican City State)",
    iso: "+379",
    countryCode: "VA",
  },
  Honduras: {
    name: "Honduras",
    iso: "+504",
    countryCode: "HN",
  },
  "Hong Kong": {
    name: "Hong Kong",
    iso: "+852",
    countryCode: "HK",
  },
  Hungary: {
    name: "Hungary",
    iso: "+36",
    countryCode: "HU",
  },
  Iceland: {
    name: "Iceland",
    iso: "+354",
    countryCode: "IS",
  },
  India: {
    name: "India",
    iso: "+91",
    countryCode: "IN",
  },
  Indonesia: {
    name: "Indonesia",
    iso: "+62",
    countryCode: "ID",
  },
  "Iran, Islamic Republic of Persian Gulf": {
    name: "Iran, Islamic Republic of Persian Gulf",
    iso: "+98",
    countryCode: "IR",
  },
  Iraq: {
    name: "Iraq",
    iso: "+964",
    countryCode: "IQ",
  },
  Ireland: {
    name: "Ireland",
    iso: "+353",
    countryCode: "IE",
  },
  "Isle of Man": {
    name: "Isle of Man",
    iso: "+44",
    countryCode: "IM",
  },
  Israel: {
    name: "Israel",
    iso: "+972",
    countryCode: "IL",
  },
  Italy: {
    name: "Italy",
    iso: "+39",
    countryCode: "IT",
  },
  Jamaica: {
    name: "Jamaica",
    iso: "+1(876)",
    countryCode: "JM",
  },
  Japan: {
    name: "Japan",
    iso: "+81",
    countryCode: "JP",
  },
  Jersey: {
    name: "Jersey",
    iso: "+44",
    countryCode: "JE",
  },
  Jordan: {
    name: "Jordan",
    iso: "+962",
    countryCode: "JO",
  },
  Kazakhstan: {
    name: "Kazakhstan",
    iso: "+7",
    countryCode: "KZ",
  },
  Kenya: {
    name: "Kenya",
    iso: "+254",
    countryCode: "KE",
  },
  Kiribati: {
    name: "Kiribati",
    iso: "+686",
    countryCode: "KI",
  },
  "Korea, Democratic People's Republic of Korea": {
    name: "Korea, Democratic People's Republic of Korea",
    iso: "+850",
    countryCode: "KP",
  },
  "Korea, Republic of South Korea": {
    name: "Korea, Republic of South Korea",
    iso: "+82",
    countryCode: "KR",
  },
  Kosovo: {
    name: "Kosovo",
    iso: "+383",
    countryCode: "XK",
  },
  Kuwait: {
    name: "Kuwait",
    iso: "+965",
    countryCode: "KW",
  },
  Kyrgyzstan: {
    name: "Kyrgyzstan",
    iso: "+996",
    countryCode: "KG",
  },
  Laos: {
    name: "Laos",
    iso: "+856",
    countryCode: "LA",
  },
  Latvia: {
    name: "Latvia",
    iso: "+371",
    countryCode: "LV",
  },
  Lebanon: {
    name: "Lebanon",
    iso: "+961",
    countryCode: "LB",
  },
  Lesotho: {
    name: "Lesotho",
    iso: "+266",
    countryCode: "LS",
  },
  Liberia: {
    name: "Liberia",
    iso: "+231",
    countryCode: "LR",
  },
  "Libyan Arab Jamahiriya": {
    name: "Libyan Arab Jamahiriya",
    iso: "+218",
    countryCode: "LY",
  },
  Liechtenstein: {
    name: "Liechtenstein",
    iso: "+423",
    countryCode: "LI",
  },
  Lithuania: {
    name: "Lithuania",
    iso: "+370",
    countryCode: "LT",
  },
  Luxembourg: {
    name: "Luxembourg",
    iso: "+352",
    countryCode: "LU",
  },
  Macao: {
    name: "Macao",
    iso: "+853",
    countryCode: "MO",
  },
  Macedonia: {
    name: "Macedonia",
    iso: "+389",
    countryCode: "MK",
  },
  Madagascar: {
    name: "Madagascar",
    iso: "+261",
    countryCode: "MG",
  },
  Malawi: {
    name: "Malawi",
    iso: "+265",
    countryCode: "MW",
  },
  Malaysia: {
    name: "Malaysia",
    iso: "+60",
    countryCode: "MY",
  },
  Maldives: {
    name: "Maldives",
    iso: "+960",
    countryCode: "MV",
  },
  Mali: {
    name: "Mali",
    iso: "+223",
    countryCode: "ML",
  },
  Malta: {
    name: "Malta",
    iso: "+356",
    countryCode: "MT",
  },
  "Marshall Islands": {
    name: "Marshall Islands",
    iso: "+692",
    countryCode: "MH",
  },
  Martinique: {
    name: "Martinique",
    iso: "+596",
    countryCode: "MQ",
  },
  Mauritania: {
    name: "Mauritania",
    iso: "+222",
    countryCode: "MR",
  },
  Mauritius: {
    name: "Mauritius",
    iso: "+230",
    countryCode: "MU",
  },
  Mayotte: {
    name: "Mayotte",
    iso: "+262",
    countryCode: "YT",
  },
  Mexico: {
    name: "Mexico",
    iso: "+52",
    countryCode: "MX",
  },
  "Micronesia, Federated States of Micronesia": {
    name: "Micronesia, Federated States of Micronesia",
    iso: "+691",
    countryCode: "FM",
  },
  Moldova: {
    name: "Moldova",
    iso: "+373",
    countryCode: "MD",
  },
  Monaco: {
    name: "Monaco",
    iso: "+377",
    countryCode: "MC",
  },
  Mongolia: {
    name: "Mongolia",
    iso: "+976",
    countryCode: "MN",
  },
  Montenegro: {
    name: "Montenegro",
    iso: "+382",
    countryCode: "ME",
  },
  Montserrat: {
    name: "Montserrat",
    iso: "+1(664)",
    countryCode: "MS",
  },
  Morocco: {
    name: "Morocco",
    iso: "+212",
    countryCode: "MA",
  },
  Mozambique: {
    name: "Mozambique",
    iso: "+258",
    countryCode: "MZ",
  },
  Myanmar: {
    name: "Myanmar",
    iso: "+95",
    countryCode: "MM",
  },
  Namibia: {
    name: "Namibia",
    iso: "+264",
    countryCode: "NA",
  },
  Nauru: {
    name: "Nauru",
    iso: "+674",
    countryCode: "NR",
  },
  Nepal: {
    name: "Nepal",
    iso: "+977",
    countryCode: "NP",
  },
  Netherlands: {
    name: "Netherlands",
    iso: "+31",
    countryCode: "NL",
  },
  "Netherlands Antilles": {
    name: "Netherlands Antilles",
    iso: "+599",
    countryCode: "AN",
  },
  "New Caledonia": {
    name: "New Caledonia",
    iso: "+687",
    countryCode: "NC",
  },
  "New Zealand": {
    name: "New Zealand",
    iso: "+64",
    countryCode: "NZ",
  },
  Nicaragua: {
    name: "Nicaragua",
    iso: "+505",
    countryCode: "NI",
  },
  Niger: {
    name: "Niger",
    iso: "+227",
    countryCode: "NE",
  },
  Nigeria: {
    name: "Nigeria",
    iso: "+234",
    countryCode: "NG",
  },
  Niue: {
    name: "Niue",
    iso: "+683",
    countryCode: "NU",
  },
  "Norfolk Island": {
    name: "Norfolk Island",
    iso: "+672",
    countryCode: "NF",
  },
  "Northern Mariana Islands": {
    name: "Northern Mariana Islands",
    iso: "+1(670)",
    countryCode: "MP",
  },
  Norway: {
    name: "Norway",
    iso: "+47",
    countryCode: "NO",
  },
  Oman: {
    name: "Oman",
    iso: "+968",
    countryCode: "OM",
  },
  Pakistan: {
    name: "Pakistan",
    iso: "+92",
    countryCode: "PK",
  },
  Palau: {
    name: "Palau",
    iso: "+680",
    countryCode: "PW",
  },
  "Palestinian Territory, Occupied": {
    name: "Palestinian Territory, Occupied",
    iso: "+970",
    countryCode: "PS",
  },
  Panama: {
    name: "Panama",
    iso: "+507",
    countryCode: "PA",
  },
  "Papua New Guinea": {
    name: "Papua New Guinea",
    iso: "+675",
    countryCode: "PG",
  },
  Paraguay: {
    name: "Paraguay",
    iso: "+595",
    countryCode: "PY",
  },
  Peru: {
    name: "Peru",
    iso: "+51",
    countryCode: "PE",
  },
  Philippines: {
    name: "Philippines",
    iso: "+63",
    countryCode: "PH",
  },
  Pitcairn: {
    name: "Pitcairn",
    iso: "+64",
    countryCode: "PN",
  },
  Poland: {
    name: "Poland",
    iso: "+48",
    countryCode: "PL",
  },
  Portugal: {
    name: "Portugal",
    iso: "+351",
    countryCode: "PT",
  },
  "Puerto Rico": {
    name: "Puerto Rico",
    iso: "+1939",
    countryCode: "PR",
  },
  Qatar: {
    name: "Qatar",
    iso: "+974",
    countryCode: "QA",
  },
  Romania: {
    name: "Romania",
    iso: "+40",
    countryCode: "RO",
  },
  Russia: {
    name: "Russia",
    iso: "+7",
    countryCode: "RU",
  },
  Rwanda: {
    name: "Rwanda",
    iso: "+250",
    countryCode: "RW",
  },
  Reunion: {
    name: "Reunion",
    iso: "+262",
    countryCode: "RE",
  },
  "Saint Barthelemy": {
    name: "Saint Barthelemy",
    iso: "+590",
    countryCode: "BL",
  },
  "Saint Helena, Ascension and Tristan Da Cunha": {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    iso: "+290",
    countryCode: "SH",
  },
  "Saint Kitts and Nevis": {
    name: "Saint Kitts and Nevis",
    iso: "+1(869)",
    countryCode: "KN",
  },
  "Saint Lucia": {
    name: "Saint Lucia",
    iso: "+1(758)",
    countryCode: "LC",
  },
  "Saint Martin": {
    name: "Saint Martin",
    iso: "+590",
    countryCode: "MF",
  },
  "Saint Pierre and Miquelon": {
    name: "Saint Pierre and Miquelon",
    iso: "+508",
    countryCode: "PM",
  },
  "Saint Vincent and the Grenadines": {
    name: "Saint Vincent and the Grenadines",
    iso: "+1(784)",
    countryCode: "VC",
  },
  Samoa: {
    name: "Samoa",
    iso: "+685",
    countryCode: "WS",
  },
  "San Marino": {
    name: "San Marino",
    iso: "+378",
    countryCode: "SM",
  },
  "Sao Tome and Principe": {
    name: "Sao Tome and Principe",
    iso: "+239",
    countryCode: "ST",
  },
  "Saudi Arabia": {
    name: "Saudi Arabia",
    iso: "+966",
    countryCode: "SA",
  },
  Senegal: {
    name: "Senegal",
    iso: "+221",
    countryCode: "SN",
  },
  Serbia: {
    name: "Serbia",
    iso: "+381",
    countryCode: "RS",
  },
  Seychelles: {
    name: "Seychelles",
    iso: "+248",
    countryCode: "SC",
  },
  "Sierra Leone": {
    name: "Sierra Leone",
    iso: "+232",
    countryCode: "SL",
  },
  Singapore: {
    name: "Singapore",
    iso: "+65",
    countryCode: "SG",
  },
  Slovakia: {
    name: "Slovakia",
    iso: "+421",
    countryCode: "SK",
  },
  Slovenia: {
    name: "Slovenia",
    iso: "+386",
    countryCode: "SI",
  },
  "Solomon Islands": {
    name: "Solomon Islands",
    iso: "+677",
    countryCode: "SB",
  },
  Somalia: {
    name: "Somalia",
    iso: "+252",
    countryCode: "SO",
  },
  "South Africa": {
    name: "South Africa",
    iso: "+27",
    countryCode: "ZA",
  },
  "South Sudan": {
    name: "South Sudan",
    iso: "+211",
    countryCode: "SS",
  },
  "South Georgia and the South Sandwich Islands": {
    name: "South Georgia and the South Sandwich Islands",
    iso: "+500",
    countryCode: "GS",
  },
  Spain: {
    name: "Spain",
    iso: "+34",
    countryCode: "ES",
  },
  "Sri Lanka": {
    name: "Sri Lanka",
    iso: "+94",
    countryCode: "LK",
  },
  Sudan: {
    name: "Sudan",
    iso: "+249",
    countryCode: "SD",
  },
  Suriname: {
    name: "Suriname",
    iso: "+597",
    countryCode: "SR",
  },
  "Svalbard and Jan Mayen": {
    name: "Svalbard and Jan Mayen",
    iso: "+47",
    countryCode: "SJ",
  },
  Swaziland: {
    name: "Swaziland",
    iso: "+268",
    countryCode: "SZ",
  },
  Sweden: {
    name: "Sweden",
    iso: "+46",
    countryCode: "SE",
  },
  Switzerland: {
    name: "Switzerland",
    iso: "+41",
    countryCode: "CH",
  },
  "Syrian Arab Republic": {
    name: "Syrian Arab Republic",
    iso: "+963",
    countryCode: "SY",
  },
  Taiwan: {
    name: "Taiwan",
    iso: "+886",
    countryCode: "TW",
  },
  Tajikistan: {
    name: "Tajikistan",
    iso: "+992",
    countryCode: "TJ",
  },
  "Tanzania, United Republic of Tanzania": {
    name: "Tanzania, United Republic of Tanzania",
    iso: "+255",
    countryCode: "TZ",
  },
  Thailand: {
    name: "Thailand",
    iso: "+66",
    countryCode: "TH",
  },
  "Timor-Leste": {
    name: "Timor-Leste",
    iso: "+670",
    countryCode: "TL",
  },
  Togo: {
    name: "Togo",
    iso: "+228",
    countryCode: "TG",
  },
  Tokelau: {
    name: "Tokelau",
    iso: "+690",
    countryCode: "TK",
  },
  Tonga: {
    name: "Tonga",
    iso: "+676",
    countryCode: "TO",
  },
  "Trinidad and Tobago": {
    name: "Trinidad and Tobago",
    iso: "+1(868)",
    countryCode: "TT",
  },
  Tunisia: {
    name: "Tunisia",
    iso: "+216",
    countryCode: "TN",
  },
  Turkey: {
    name: "Turkey",
    iso: "+90",
    countryCode: "TR",
  },
  Turkmenistan: {
    name: "Turkmenistan",
    iso: "+993",
    countryCode: "TM",
  },
  "Turks and Caicos Islands": {
    name: "Turks and Caicos Islands",
    iso: "+1(649)",
    countryCode: "TC",
  },
  Tuvalu: {
    name: "Tuvalu",
    iso: "+688",
    countryCode: "TV",
  },
  Uganda: {
    name: "Uganda",
    iso: "+256",
    countryCode: "UG",
  },
  Ukraine: {
    name: "Ukraine",
    iso: "+380",
    countryCode: "UA",
  },
  "United Arab Emirates": {
    name: "United Arab Emirates",
    iso: "+971",
    countryCode: "AE",
  },
  "United Kingdom": {
    name: "United Kingdom",
    iso: "+44",
    countryCode: "GB",
  },
  "United States": {
    name: "United States",
    iso: "+1",
    countryCode: "US",
  },
  Uruguay: {
    name: "Uruguay",
    iso: "+598",
    countryCode: "UY",
  },
  Uzbekistan: {
    name: "Uzbekistan",
    iso: "+998",
    countryCode: "UZ",
  },
  Vanuatu: {
    name: "Vanuatu",
    iso: "+678",
    countryCode: "VU",
  },
  "Venezuela, Bolivarian Republic of Venezuela": {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    iso: "+58",
    countryCode: "VE",
  },
  Vietnam: {
    name: "Vietnam",
    iso: "+84",
    countryCode: "VN",
  },
  "Virgin Islands, British": {
    name: "Virgin Islands, British",
    iso: "+1(284)",
    countryCode: "VG",
  },
  "Virgin Islands, U.S.": {
    name: "Virgin Islands, U.S.",
    iso: "+1(340)",
    countryCode: "VI",
  },
  "Wallis and Futuna": {
    name: "Wallis and Futuna",
    iso: "+681",
    countryCode: "WF",
  },
  Yemen: {
    name: "Yemen",
    iso: "+967",
    countryCode: "YE",
  },
  Zambia: {
    name: "Zambia",
    iso: "+260",
    countryCode: "ZM",
  },
  Zimbabwe: {
    name: "Zimbabwe",
    iso: "+263",
    countryCode: "ZW",
  },
};

export const COUNTRIES_LIST = Object.values(COUNTRIES_PER_NAME);

export const COUNTRY_NAMES = Object.keys(COUNTRIES_PER_NAME);
